import { GButton } from "./GButton";
import { LayoutType, ScrollBounceBackEffect, SelectionMode } from "./Const";
import { WidgetPool } from "./WidgetPool";
import { ListLayout } from "./layout/ListLayout";
import { ListSelection } from "./selection/ListSelection";
import { GPanel } from "./GPanel";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { LayaEnv } from "../../LayaEnv";
import { HideFlags } from "../Const";
export class GList extends GPanel {
    constructor() {
        super(ListLayout, ListSelection);
        this._layout.type = LayoutType.SingleColumn;
        this._selection.mode = SelectionMode.Single;
        this._pool = new WidgetPool();
    }
    destroy() {
        this._pool.clear();
        super.destroy();
    }
    get layout() {
        return this._layout;
    }
    get itemTemplate() {
        return this._pool.defaultRes;
    }
    set itemTemplate(value) {
        this._pool.defaultRes = value;
    }
    get itemPool() {
        return this._pool;
    }
    getFromPool(url) {
        let obj = this._pool.take(url);
        if (obj)
            obj.visible = true;
        return obj;
    }
    returnToPool(obj) {
        this._pool.recover(obj);
    }
    addItemFromPool(url) {
        let child = this.getFromPool(url);
        if (child instanceof GButton)
            child.selected = false;
        return this.addChild(child);
    }
    removeChildToPoolAt(index) {
        let child = this.removeChildAt(index);
        this.returnToPool(child);
    }
    removeChildToPool(child) {
        this.removeChild(child);
        this.returnToPool(child);
    }
    removeChildrenToPool(beginIndex, endIndex) {
        beginIndex = beginIndex || 0;
        if (endIndex == null)
            endIndex = -1;
        if (endIndex < 0 || endIndex >= this.children.length)
            endIndex = this.children.length - 1;
        for (let i = beginIndex; i <= endIndex; ++i)
            this.removeChildToPoolAt(beginIndex);
    }
    get numItems() {
        return this._layout.numItems;
    }
    set numItems(value) {
        this._layout.numItems = value;
    }
    resizeToFit(itemCount, minSize) {
        this._layout.resizeToFit(itemCount, minSize);
    }
    childIndexToItemIndex(index) {
        return this._layout.childIndexToItemIndex(index);
    }
    itemIndexToChildIndex(index) {
        return this._layout.itemIndexToChildIndex(index);
    }
    refreshVirtualList() {
        this._layout.refreshVirtualList();
    }
    setVirtual() {
        this._setVirtual(false);
    }
    setVirtualAndLoop() {
        this._setVirtual(true);
    }
    _setVirtual(loop) {
        if (!this._layout._virtual) {
            if (this.scroller == null)
                throw new Error("Virtual list must be scrollable!");
            if (loop) {
                if (this._layout.type == LayoutType.FlowX || this._layout.type == LayoutType.FlowY)
                    throw new Error("Loop list does not support flowX or flowY layout!");
                this.scroller.bouncebackEffect = ScrollBounceBackEffect.Off;
            }
        }
        this._layout._setVirtual(loop);
    }
    onAfterDeserialize() {
        super.onAfterDeserialize();
        if (SerializeUtil.hasProp("_initItemNum", "_itemData") && (LayaEnv.isPreview || !SerializeUtil._data._isDemo))
            this._buildInitItems();
    }
    _buildInitItems() {
        for (let i = this.children.length - 1; i >= 0; i--) {
            let child = this.getChildAt(i);
            if (child.hasHideFlag(HideFlags.HideAndDontSave))
                child.destroy();
        }
        if (this.itemTemplate == null)
            return;
        let itemData = this._itemData;
        for (let i = 0; i < this._initItemNum; i++) {
            let m = (itemData && i < itemData.length) ? itemData[i] : null;
            if (m != null) {
                let child = (m.res ? m.res.create() : this.getFromPool());
                child.hideFlags |= HideFlags.HideAndDontSave;
                child.text = m.title;
                if (m.icon)
                    child.icon = m.icon;
                if (child instanceof GButton) {
                    if (m.selectedTitle)
                        child.selectedTitle = m.selectedTitle;
                    if (m.selectedIcon)
                        child.selectedIcon = m.selectedIcon;
                    child.selected = false;
                }
                if (m.name != null)
                    child.name = m.name;
                this.addChild(child);
            }
            else
                this.addItemFromPool();
        }
        this.selection._refresh();
    }
}
